import Alpine from 'alpinejs'
import { filterPois } from "./poi";

let everyFilterEnabledCheckbox;
let filters;
let details;
let detailsBackdrop;
let filtersBackdrop;

addEventListener('load', () => {
    everyFilterEnabledCheckbox = document.getElementById('every-filter-enabled');
    filters = document.getElementById('filter-menu');
    filtersBackdrop = document.getElementById('filter-menu-backdrop');
    details = document.getElementById('details');
    detailsBackdrop = document.getElementById('details-backdrop');
});

export function startAlpine() {
    Alpine.store('selectedPoi', {
        values: [],
        size: 0,
        index: 0,

        set(values, size = 0) {
            this.values = values ? values : [];
            for (const val of this.values) {
                if (val.website) {
                    val.socialLinks['website'] =
                        val.website.startsWith('www') ? `http://${val.website}` : val.website;
                }
                if (val.email) {
                    val.socialLinks['email'] = val.email;
                }
            }
            this.size = size;
            this.index = 0;
        },

        getSelected() {
            if (this.size) {
                return this.values[this.index];
            }
        },

        getIndex() {
            return this.index;
        },

        getSize() {
            return this.size;
        },

        next() {
            if (this.index < this.size - 1) {
                this.index++;
            }
        },

        prev() {
            if (this.index > 0) {
                this.index--;
            }
        }
    });

    Alpine.store('filters', {
        collection: {
            STORE: {
                id: 'STORE',
                allEnabled: true,
                open: false,
                name: "Üzletek",
                subcategories:
                    {
                        ZERO_WASTE: { id: 'ZERO_WASTE', value: "Csomagolásmentes", enabled: true },
                        MARKET: { id: 'MARKET', value: "Piac", enabled: true },
                        LOCAL_PRODUCER: { id: 'LOCAL_PRODUCER', value: "Termelői bolt", enabled: true },
                        USED_GADGETS: { id: 'USED_GADGETS', value: "Használt tárgyak", enabled: true },
                        USED_CLOTHES: { id: 'USED_CLOTHES', value: "Használt ruha", enabled: true },
                        DONATION_SHOP: { id: 'DONATION_SHOP', value: "Adománybolt", enabled: true },
                        BOOK_STORE: { id: 'BOOK_STORE', value: "Könyv", enabled: true },
                        FARM_STORE: { id: 'FARM_STORE', value: "Gazdaság", enabled: true }
                    }
            },
            RESTAURANT: {
                id: 'RESTAURANT',
                allEnabled: true,
                open: false,
                name: "Vendéglátóhelyek",
                subcategories:
                    {
                        RESTAURANT: { id: 'RESTAURANT', value: "Étterem", enabled: true },
                        CAKE_SHOP: { id: 'CAKE_SHOP', value: "Cukrászda", enabled: true },
                        BAKERY: { id: 'BAKERY', value: "Pékség", enabled: true },
                        CAFE: { id: 'CAFE', value: "Kávézó", enabled: true }
                    }
            },
            RENTAL: {
                id: 'RENTAL',
                allEnabled: true,
                open: false,
                name: "Kölcsönzés",
                subcategories:
                    {
                        SPORTS_EQUIPMENT: { id: 'SPORTS_EQUIPMENT', value: "Sportszer kölcsönzés", enabled: true },
                        BIKE_RENTAL: { id: 'BIKE_RENTAL', value: "Bringa kölcsönzés", enabled: true },
                        CAR_RENTAL: { id: 'CAR_RENTAL', value: "Autó kölcsönzés", enabled: true },
                        MACHINE_RENTAL: { id: 'MACHINE_RENTAL', value: "Gép kölcsönzés", enabled: true },
                        LIBRARY: { id: 'LIBRARY', value: "Könyvtár", enabled: true }
                    }
            },
            REPAIR: {
                id: 'REPAIR',
                allEnabled: true,
                open: false,
                name: "Javítás",
                subcategories:
                    {
                        BIKE_REPAIR: { id: 'BIKE_REPAIR', value: "Bringa szervíz", enabled: true },
                        CLOTHES_REPAIR: { id: 'CLOTHES_REPAIR', value: "Ruha javítás", enabled: true },
                        SHOE_MAKER: { id: 'SHOE_MAKER', value: "Cipész", enabled: true },
                        HOUSEHOLD_APPLIANCE: {
                            id: 'HOUSEHOLD_APPLIANCE',
                            value: "Háztartási gép szervíz",
                            enabled: true
                        },
                        WATCH_MAKER: { id: 'WATCH_MAKER', value: "Órás", enabled: true },
                        ELECTRIC_DEVICE: { id: 'ELECTRIC_DEVICE', value: "Elektronikai szervíz", enabled: true },
                        COOP: { id: 'COOP', value: "Közösségi műhely", enabled: true },
                        CARPENTER: { id: 'CARPENTER', value: "Asztalos", enabled: true }
                    }
            },
            WASTE: {
                id: 'WASTE',
                allEnabled: true,
                open: false,
                name: "Hulladék",
                subcategories:
                    {
                        SELECTIVE: { id: 'SELECTIVE', value: "Szelektív sziget", enabled: true },
                        COMPOST: { id: 'COMPOST', value: "Komposzt", enabled: true },
                        CLOTHES_DROPOFF: { id: 'CLOTHES_DROPOFF', value: "Ruha leadás", enabled: true },
                        ELECTRIC_WASTE: { id: 'ELECTRIC_WASTE', value: "Elektronikai hulladék", enabled: true },
                        USED_BATTERY: { id: 'USED_BATTERY', value: "Használt elem", enabled: true },
                        USED_OIL: { id: 'USED_OIL', value: "Használt olaj", enabled: true },
                        USED_BOOKS: { id: 'USED_BOOKS', value: "Használt könyv", enabled: true },
                    }
            },
            STATION: {
                id: 'STATION',
                allEnabled: true,
                open: false,
                name: "Állomás",
                subcategories:
                    {
                        TOILET: { id: 'TOILET', value: "Nyilvános WC", enabled: true },
                        MOBILITY_POINT: { id: 'MOBILITY_POINT', value: "Mobilitási pont", enabled: true },
                        CHARGING_STATION: { id: 'CHARGING_STATION', value: "Elektromos töltőállomás", enabled: true },
                        WATER: { id: 'WATER', value: "Ivóvíz", enabled: true },
                        BIKE_SHARING: { id: 'BIKE_SHARING', value: "Bringa megosztás", enabled: true },
                        NATURE: {
                            id: 'NATURE', value: "Természet", enabled: true
                        }
                    },
            },
            COMMON_GOOD: {
                id: 'COMMON_GOOD',
                allEnabled: true,
                open: false,
                name: "Közösség",
                subcategories: {
                    SPORT_FACILITY: { id: 'SPORT_FACILITY', value: "Sport", enabled: true },
                    COMMUNITY_GARDEN: { id: 'COMMUNITY_GARDEN', value: "Közösségi kert", enabled: true },
                    VOLUNTARY_POINT: { id: 'VOLUNTARY_POINT', value: "Önkéntes hely", enabled: true },
                    PLAYGROUND: { id: 'PLAYGROUND', value: "Játszótér", enabled: true },
                    COMMUNITY_CENTER: { id: 'COMMUNITY_CENTER', value: "Művelődési ház", enabled: true },
                }
            },
            EVENT: {
                id: 'EVENT',
                allEnabled: true,
                open: false,
                name: "Esemény",
                subcategories:
                    {
                        COMMUNITY_EVENT: { id: 'COMMUNITY_EVENT', value: "Közösségi esemény", enabled: true },
                        WORKSHOP: { id: 'WORKSHOP', value: "Workshop", enabled: true },
                        JUNK_CLEARANCE: { id: 'JUNK_CLEARANCE', value: "Lomtalanítás", enabled: true },
                        CHARITY: { id: 'CHARITY', value: "Jótékonyság", enabled: true },
                        PICK_IT_YOURSELF: { id: 'PICK_IT_YOURSELF', value: "Szedd magad", enabled: true },
                        MARKET: { id: 'MARKET', value: "Vásár", enabled: true },
                        VOLUNTEERING: { id: 'VOLUNTEERING', value: "Önkénteskedés", enabled: true }
                    }
            },
            SUCCESS_STORY: {
                id: 'SUCCESS_STORY',
                allEnabled: true,
                open: false,
                name: "Sikersztori",
                subcategories:
                    {
                        BAD_STORY: { id: 'BAD_STORY', value: 'Amin dolgozni kell', enabled: true },
                        GOOD_STORY: { id: 'GOOD_STORY', value: 'Remek ötlet', enabled: true },
                        POWER_OF_COMMUNITY: { id: 'POWER_OF_COMMUNITY', value: 'A közösség ereje', enabled: true },
                    }
            }
        },

        open: false,
        everyFilterEnabled: true,

        toggleAllFiltersAndSubcategories() {
            this.everyFilterEnabled = !this.everyFilterEnabled;
            Object.values(this.collection).forEach(collection => {
                collection.allEnabled = this.everyFilterEnabled;
                const checkbox = document.getElementById(collection.id);
                checkbox.indeterminate = false;
                Object.values(collection.subcategories).forEach(subcategory => subcategory.enabled = this.everyFilterEnabled)
            });
            filterPois();
        },

        toggleMainFilter(id) {
            this.collection[id].allEnabled = !this.collection[id].allEnabled;
            Object.values(this.collection[id].subcategories).forEach(subcategory => subcategory.enabled = this.collection[id].allEnabled)
            filterPois();
        },

        toggleSubFilter(categoryId, subcategoryId) {
            this.collection[categoryId].subcategories[subcategoryId].enabled = !this.collection[categoryId].subcategories[subcategoryId].enabled;
            let allSame = true;
            Object.values(this.collection[categoryId].subcategories).forEach(subcategory => {
                if (subcategory.enabled !== this.collection[categoryId].subcategories[subcategoryId].enabled) {
                    allSame = false;
                }
            })
            const collectionCheckbox = document.getElementById(categoryId);
            if (allSame) {
                this.collection[categoryId].allEnabled = this.collection[categoryId].subcategories[subcategoryId].enabled;
                collectionCheckbox.indeterminate = false;
            } else {
                this.collection[categoryId].allEnabled = false;
                collectionCheckbox.indeterminate = true;
                this.everyFilterEnabled = false;
                everyFilterEnabledCheckbox.indeterminate = true;
            }

            filterPois();
        },

        openFiltersMenu() {
            this.open = true;
            filters.classList.remove('filters-closed');
            filtersBackdrop.style.display = 'block';
        },

        closeFiltersMenu() {
            this.open = false;
            filters.classList.add('filters-closed');
            filtersBackdrop.style.display = 'none';
        },

        toggleDropdown(id) {
            this.collection[id].open = !this.collection[id].open;
        }
    });

    Alpine.store('details', {
        open: false,
        contactSliderOpen: false,

        toggleDetails() {
            if (this.open) {
                this.closedDetails();
            } else {
                this.openDetails();
            }
        },

        openDetails() {
            this.open = true;
            details.classList.remove('off-screen');
            detailsBackdrop.style.display = 'block';
        },

        closeDetails() {
            this.open = false;
            details.classList.add('off-screen');
            detailsBackdrop.style.display = 'none';
        },

        toggleContactSlider() {
            if (window.innerWidth <= 450) this.contactSliderOpen = !this.contactSliderOpen;
        },

        openContactSlider() {
            if (window.innerWidth > 450) this.contactSliderOpen = true;
        },

        closeContactSlider() {
            if (window.innerWidth > 450) this.contactSliderOpen = false;
        }

    });

    Alpine.start();
}